import React, { Component,  } from 'react';
import YouTube from 'react-youtube';
// import logo from "../assets/fundacionClinica.svg";
import logo from "../assets/femcc-01/logo.png";
import ecopetrol from "../assets/femcc-01/campania-ecoptrol.jpeg";

import './videoplayer.css';


class VideoPlayer extends Component  {
    
    constructor(props) {
        super(props);
        console.log(props.videos.split(","))
        this.state = {
            windowWidth: window.innerWidth,
            videos: 
                props.videos.split(","),
            isMuted: true,
            currentVideo: 0,
        };

        
    }


    
    async componentDidMount() {
        window.addEventListener('resize', this.handleResize);

        // console.log(videos)
        
    }
    
    componentWillUnmount() {
        window.removeEventListener('resize', this.handleResize);
    }
    
    handleResize = () => {
        this.setState({ windowWidth: window.innerWidth });
    };

    playVideo = (index) => {
        this.setState({ currentVideo: index });
    };

    onEnd = () => {
        const { currentVideo, videos } = this.state;
        const nextVideo = (currentVideo + 1) % videos.length;
        this.setState({ currentVideo: nextVideo });
    };



    render(){

        const { windowWidth, videos, currentVideo } = this.state;
        const videoWidth = windowWidth > 400 ? windowWidth * 0.8 : windowWidth;

        
        const videoOpts = {
            height: 300,
            width:  videoWidth.toString(),
            origin: window.location.href,
            playerVars: {
                autoplay: 1,  // Autoplay the video
                loop: 1,     // Loop the video
                mute: 1,      // Mute the video
                playlist: videos.join(','),
                fs: 0, // Hide fullscreen button (0)
                controls: 1, // Hide video controls
                modestbranding: 1, // Hide YouTube logo
                rel: 0,
                showinfo: 0, // Hide video title and uploader infocontrols: 0, // Hide video controls
                disablekb: 1, // Disable keyboard controls (including volume control)
                iv_load_policy: 3, // Disable video annotations
                start: 0, // Start playing from the beginning (0)
                wmode: 'opaque',
                loading: 'lazy',
              
            },
        };
        


    
        return(
            <div >
                
                {/* <div className='col-6'>
                    <div className="d-grid gap-2 mt-2 mb-2">
                        <img id="imgPrint" style={{height:'auto',width:'30%'}} src={ logo } alt=''/>
                    </div>
                </div> */}
                
                <div className="video-container">
                    <div className="text-center video-player">
                        <YouTube
                        videoId={videos[currentVideo]}
                        opts={videoOpts}
                        onEnd={this.onEnd}
                        onReady={this._onReady}
                        
                        />
                    </div>
                </div>
                <div className="d-grid gap-2 mt-2 mb-2 ">
                     <img id="imgPrint" className="d-block mx-auto" style={{height:'90%',width:'100%'}} src={ ecopetrol } alt=''/>
                </div>
                
            </div >
        );



    }

    _onReady(event) {
        event.target.mute();        // ✅ fuerza silencio
        event.target.playVideo();
        // Access to player in all event handlers via event.target
        // event.target.pauseVideo();
      }

  
};

export default VideoPlayer;